import { Component } from 'react';
import { defaultCustomRender } from 'helpers/chartRender.helper';
import { Box, ChartHistory } from 'components/common';
import EntryBy from 'components/common/entry-by/EntryBy';
import { FormField, LaborProgressHistoryProps } from './constants';

class LaborProgressUterineActivityHistoryTable extends Component<LaborProgressHistoryProps> {
  static displayName = 'LaborProgressUterineActivityHistoryTable';

  entryByRenderer = (record) => <EntryBy record={record} />;

  render() {
    const { chartHistory, deleteHistory } = this.props;
    const actionHeader = deleteHistory ? { field: 'actionDelete' } : {};
    const dataSource = {
      headers: [
        { text: 'Chart Time', field: 'chartingAt', sortable: true },
        { text: 'Monitor Mode', field: 'monitorModeDropDown', customRender: defaultCustomRender(FormField.MONITOR_MODE_DROPDOWN) },
        { text: 'Frequency (minutes)', field: 'frequency', customRender: defaultCustomRender(FormField.FREQUENCY) },
        { text: 'Duration (seconds)', field: 'duration', customRender: defaultCustomRender(FormField.DURATION) },
        { text: 'Intensity', field: 'intensity', customRender: defaultCustomRender(FormField.INTENSITY) },
        { text: 'Notes', field: 'notes', customRender: defaultCustomRender(FormField.NOTES) },
        { text: 'Entry By', field: 'entryBy', customRender: this.entryByRenderer },
        { ...actionHeader }
      ],
      css: ['column__chart-time', '', '', '', '', '', 'column__entry-by', 'column__delete'],
      data: chartHistory
    };
    return (
      <Box mt className="labor-progress-history">
        <ChartHistory dataSource={dataSource} deleteRecord={deleteHistory} />
      </Box>
    );
  }
}

export default LaborProgressUterineActivityHistoryTable;
